<script>

export default {
	components: {
	},
	props: {
	},
	data() {
		return {}
	},
	computed: {
	},
	methods: {
	},
}
</script>

<template>

	<footer>
		<div id="footer" class="ext">
			<div class="int">
				<div class="line informacoes-legais" style="padding-left: 100px;">
					<div class="col85">
						<p>© 2016, LA VILLE CASA ONLINE TODOS OS DIREITOS RESERVADOS. As fotos aqui veiculadas, logotipo e marca são de propriedade de www.lavillecasa.com.br. É vedada a sua reprodução, total ou parcial. Com sede em Belo Horizonte/MG. CNPJ: 05.529.117/0007-76 - Televendas (31) 3235-8200 – e-mail:vendas@lavillecasa.com.br.</p>
					</div>
				</div>
			</div>
		</div>
	</footer>
	
</template>

<style lang="scss">

footer { margin-top: 40px; }

#footer {
    background: #DFDCD3;
    padding: 20px 0;
}

.line.footer {
	width: 75%;
	float: right;
	right: 0;
	margin: 30px 0 20px 0;	
}

.informacoes-legais p {
    padding: 5px 0;
    color: #666;
    font-size: 13px
}

</style>
